export type nullish = undefined | null

export const isNull = (v: any) : v is null => {
    return v === null;
}
export const isUndefined = (v: any) : v is undefined => {
    return v === undefined;
}
export const isSet = <T>(v: T) : v is NonNullable<T> => {
    return v !== undefined && v !== null
}
export const isUnset = (v: any) : v is nullish => {
    return (v === undefined || v === null)
}
export const ifIsSet = <T,TReturn>(v: T|nullish, callback: (v:NonNullable<T>) => TReturn, fallback: TReturn) => isSet(v) ? callback(v) : fallback
